import { createContext } from "react";
export const AwsRumContext = createContext(undefined);
